<div class="w-full max-w-120 sm:w-120 mx-auto sm:mx-0">
  <!-- Title -->
  <div class="mt-8 text-4xl font-extrabold tracking-tight leading-tight">{{'Log in to your account' | transloco}}
  </div>
  <div class="flex items-baseline mt-0.5 font-medium ">
    <div>{{'Welcome back! Log in to your account' | transloco}}</div>
  </div>

  <!-- Alert -->
  <fuse-alert class="mt-8" *ngIf="showAlert" [appearance]="'outline'" [showIcon]="false" [type]="alert.type"
    [@shake]="alert.type === 'error'">
    {{alert.message}}
  </fuse-alert>

  <!-- Sign in form -->
  <form class="mt-8" [formGroup]="signInForm" #signInNgForm="ngForm">

    <!-- Email field -->
    <mat-form-field class="w-full">
      <mat-label>{{'Email address' | transloco}}</mat-label>
      <input id="email" matInput [formControlName]="'identifier'">
      <mat-error *ngIf="signInForm.get('identifier').hasError('required')">
        {{'Email address is required' | transloco}}
      </mat-error>
      <mat-error *ngIf="signInForm.get('identifier').hasError('email')">
        {{'Please enter a valid email address' | transloco}}
      </mat-error>
    </mat-form-field>

    <!-- Password field -->
    <mat-form-field class="w-full">
      <mat-label>{{'Password' | transloco}}</mat-label>
      <input id="password" matInput type="password" [formControlName]="'password'" #passwordField>
      <button mat-icon-button type="button"
        (click)="passwordField.type === 'password' ? passwordField.type = 'text' : passwordField.type = 'password'"
        matSuffix>
        <mat-icon class="icon-size-5" *ngIf="passwordField.type === 'password'"
          [svgIcon]="'heroicons_solid:eye'"></mat-icon>
        <mat-icon class="icon-size-5" *ngIf="passwordField.type === 'text'"
          [svgIcon]="'heroicons_solid:eye-off'"></mat-icon>
      </button>
      <mat-error>
        {{'Password is required' | transloco}}
      </mat-error>
    </mat-form-field>

    <!-- Actions -->
    <div class="inline-flex items-center justify-between w-full mt-1.5">
      <a class="text-md font-medium text-primary-500 hover:underline" [routerLink]="['/',activeLang,'forgot-password']">
        {{'Forgot password?' | transloco}}
      </a>
    </div>

    <!-- Submit button -->
    <button class="fuse-mat-button-large w-full mt-6 rounded-none" mat-flat-button [color]="'primary'"
      [disabled]="signInForm.disabled || signInForm.invalid" (click)="signIn()">
      <span *ngIf="!signInForm.disabled">
        {{'Sign in' | transloco}}
      </span>
      <mat-progress-spinner *ngIf="signInForm.disabled" [diameter]="24" [mode]="'indeterminate'"></mat-progress-spinner>
    </button>


    <ng-container *ngIf="false">

      <!-- Separator -->
      <div class="flex items-center mt-8">
        <div class="flex-auto mt-px border-t"></div>
        <div class="mx-2 text-secondary">Or continue with</div>
        <div class="flex-auto mt-px border-t"></div>
      </div>

      <!-- Single sign-on buttons -->
      <div class="flex items-center mt-8 space-x-4">
        <button class="flex-auto" type="button" mat-stroked-button>
          <mat-icon class="icon-size-5" [svgIcon]="'feather:facebook'"></mat-icon>
        </button>
        <button class="flex-auto" type="button" mat-stroked-button>
          <mat-icon class="icon-size-5" [svgIcon]="'feather:twitter'"></mat-icon>
        </button>
        <button class="flex-auto" type="button" mat-stroked-button>
          <mat-icon class="icon-size-5" [svgIcon]="'feather:github'"></mat-icon>
        </button>
      </div>
    </ng-container>
  </form>

</div>